(function (tests) {
  'use strict';

  function amplitudeABTestIdentify() {
    const TEST_NAME_MAP = {
      viewRestrictionWithoutAccount: 'view_restriction_without_account',
      semanticRecsVsLiRecs: 'semantic_recs_vs_li_recs_2021q4'
    };

    if (tests) {
      const identity = new amplitude.Identify();

      Object.keys(tests).forEach((testName) => {
        const value = tests[testName]
        if (value !== 'none') {
          identity.set(TEST_NAME_MAP[testName], tests[testName]);
        }
      });

      amplitude.getInstance().identify(identity);
    }
  }

  if (typeof amplitude !== 'undefined') {
    amplitudeABTestIdentify();
  }
})(window.ab_tests);
